<div class="container">
    <h1>Unauthorized</h1>
    <p>You do not have permission to access this page.</p>
</div>
